// src/components/tasks/ui/TaskCardUI.tsx
import { cn } from "@/lib/utils"
import type { HTMLAttributes } from "react"

export const taskCardTheme = {
  // Основная карточка — стекло с фиолетовым оттенком
  card: cn(
    "relative bg-purple-950/65 backdrop-blur-2xl border border-purple-300/40",
    "rounded-3xl overflow-hidden shadow-2xl shadow-purple-500/25",
    "hover:shadow-purple-600/40 hover:border-purple-300/60 hover:bg-purple-950/75",
    "transition-all duration-300 hover:-translate-y-0.5"
  ),

  // ==================== ПРОГРЕСС-КРУГ ====================
  progressContainer: "relative shrink-0",
  progressSvg: "transition-all duration-1000 ease-out",

  // Цвет фона круга (светлее, чем было)
  progressBackground: "#334155",

  // Цвет самой диаграммы (светлый фиолетовый, хорошо видно)
  progressColor: (progress: number) => 
    progress === 100 ? "#10b981" : "#c084fc",

  // ==================== ОСТАЛЬНЫЕ СТИЛИ ====================
  titleContainer: "flex items-center gap-4 mb-4",
  title: "text-2xl font-bold text-white line-clamp-2",

  infoText: "text-purple-200 text-lg mb-3",
  observersText: "text-amber-300 text-lg mb-3 flex items-center gap-2",

  deadline: (isOverdue: boolean) =>
    `flex items-center gap-2 mb-6 ${isOverdue ? "text-red-400 font-medium" : "text-purple-300"}`,

  buttonAccepted: "px-6 py-2.5 text-sm font-bold rounded-2xl bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white shadow-lg shadow-purple-500/30 transition-all",
  buttonInReview: "px-6 py-2.5 text-sm font-bold rounded-2xl bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white shadow-lg shadow-purple-500/30 transition-all",
  buttonRework: "px-6 py-2.5 text-sm font-bold rounded-2xl border border-red-400/60 text-red-300 hover:bg-red-950/70 hover:border-red-400 transition-all",
  buttonApproved: "px-6 py-2.5 text-sm font-bold rounded-2xl bg-gradient-to-r from-emerald-500 to-teal-500 hover:from-emerald-600 hover:to-teal-600 text-white shadow-lg shadow-emerald-500/30 transition-all",
  buttonChat: "px-6 py-2.5 text-sm font-bold rounded-2xl bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white shadow-lg transition-all",
  buttonReassign: "px-6 py-2.5 text-sm font-bold rounded-2xl bg-gradient-to-r from-cyan-500 to-teal-500 hover:from-cyan-600 hover:to-teal-600 text-white shadow-lg shadow-cyan-500/30 transition-all",
  buttonAddObserver: "px-6 py-2.5 text-sm font-bold rounded-2xl bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white shadow-lg shadow-amber-500/30 transition-all",
  buttonDelete: "px-6 py-2.5 text-sm font-bold rounded-2xl bg-red-600/90 hover:bg-red-700 text-white transition-all",

  badgeNew: "absolute top-4 right-4 bg-emerald-500 text-white px-4 py-1 rounded-2xl text-sm font-bold shadow-lg",
  badgeUnread: "absolute top-4 left-4 bg-orange-500 text-white rounded-2xl w-12 h-12 flex items-center justify-center text-lg font-bold shadow-lg animate-pulse",

  approvedBadge: "px-6 py-2.5 text-sm font-bold text-white bg-gradient-to-r from-emerald-500 to-teal-500 rounded-2xl shadow-lg flex items-center gap-2 border border-emerald-400/30",

  dialogContent: "bg-slate-900/95 border-purple-300/30 backdrop-blur-2xl text-white max-w-md",
  selectTrigger: "bg-slate-800/80 border-purple-300/40 text-white focus:border-purple-400 focus:ring-purple-400",
  selectContent: "bg-slate-900/95 border-purple-300/30 backdrop-blur-2xl text-white max-h-60 overflow-y-auto shadow-2xl",
} as const